import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initGoogleAnalytics, initMetaPixel } from './analytics';
import './index.css';

initMetaPixel();
initGoogleAnalytics();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
